import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ConversationHeaderComponent } from './conversation-header/conversation-header.component';
import { ConversationDetailsComponent } from './conversation-details/conversation-details.component';
import { FirebaseModule } from '../firebase/firebase.module';
import { DashboardWorkListFilterComponent } from './dashboard-work-list-filter/dashboard-work-list-filter.component';
import { SummaryCardComponent } from './summary-card/summary-card.component';

@NgModule({
  declarations: [ConversationHeaderComponent, ConversationDetailsComponent, DashboardWorkListFilterComponent, SummaryCardComponent],
  imports: [CommonModule, FirebaseModule, TooltipModule],
  exports: [ConversationHeaderComponent, ConversationDetailsComponent, DashboardWorkListFilterComponent, SummaryCardComponent],
})
export class VoiceAiModule {}
